import type { PersonEntity } from '@festina/legalentity-general-types/legalentity'
import { dateUtils, type Optional } from '@festina-life/core'

import female from '../../images/female.svg'
import male from '../../images/male.svg'
import unknownGender from '../../images/unknownGender.svg'

export const calculateAge = ({
  startDate,
  endDate,
  systemTime,
}: {
  startDate: Optional<string>
  endDate: Optional<string>
  systemTime: Optional<string>
}) => {
  const isDeceased = dateUtils.isValidDate(endDate)

  return {
    age: dateUtils.getAgeInYears(startDate, isDeceased ? endDate : systemTime),
    isDeceased,
  }
}

export const findMemberIcon = (gender: PersonEntity['gender']) => {
  if (gender === 'Male') {
    return male
  } else if (gender === 'Female') {
    return female
  } else {
    return unknownGender
  }
}
